/*
BEDROCK Core
Copyright (c) 2026 Patrick Schimmelpfennig

All rights reserved.

Unauthorized copying, modification, distribution or use of this software,
in whole or in part, is strictly prohibited without explicit written permission
from the author or an authorized BEDROCK license grant.
*/

import { createApp } from "vue"
import App from "./App.vue"
import router from "./router"

import { initializeAuth } from "@/domain/auth/auth.service"
import { initializeNavigation } from "@/domain/navigation"

import { bootstrapBedrock } from "@/framework/bootstrap"
import { coreTabs } from "@/domain/tabs/coreTabs"

import "@/presentation/style/main.scss"

async function bootstrap() {

    const app = createApp(App)

    /*
    |--------------------------------------------------------
    | Global Error Handler
    |--------------------------------------------------------
    */
    app.config.errorHandler = (err, instance, info) => {
        if (import.meta.env.VITE_DEBUG) {
            console.error("Global Error:", err)
        }
    }

    /*
    |--------------------------------------------------------
    | Register Plugins
    |--------------------------------------------------------
    */
    app.use(router)

    /*
    |--------------------------------------------------------
    | Framework Bootstrap
    |--------------------------------------------------------
    */
    bootstrapBedrock(app)

    /*
    |--------------------------------------------------------
    | Core Providers
    |--------------------------------------------------------
    */
    app.provide("coreTabs", coreTabs)

    /*
    |--------------------------------------------------------
    | System Initialization
    |--------------------------------------------------------
    */

    await initializeAuth()
    await initializeNavigation()

    /*
    |--------------------------------------------------------
    | Mount Application
    |--------------------------------------------------------
    */
    app.mount("#app")
}

bootstrap()